// src/components/PrivateRoute.js
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PrivateRoute = ({ element, allow }) => {
  const [authState, setAuthState] = useState({ checked: false, valid: false, role: "" });
  const location = useLocation();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setAuthState({ checked: true, valid: false, role: "" });
      return;
    }

    try {
      const decoded = jwtDecode(authToken);

      // Check expiry
      const expired = decoded.exp * 1000 < Date.now();
      if (expired) {
        localStorage.removeItem("authToken");
        setAuthState({ checked: true, valid: false, role: "" });
      } else {
        setAuthState({ checked: true, valid: true, role: decoded.role || "" });
      }
    } catch (err) {
      console.error("Invalid token:", err.message);
      localStorage.removeItem("authToken");
      setAuthState({ checked: true, valid: false, role: "" });
    }
  }, []);

  if (!authState.checked) return null; // Or show spinner

  // Redirect to login if no valid token
  if (!authState.valid) return <Navigate to="/" state={{ from: location }} replace />;

  // If `allow` prop is passed, check role
  if (Array.isArray(allow) && allow.length > 0) {
    if (!allow.includes(authState.role)) {
      return <Navigate to="/403" replace />;
    }
  }

  // Authorized → render page
  return element;
};

export default PrivateRoute;
